export default __webpack_public_path__ + "static/media/b-15.70744f50.png";